<template>

    <modal-container>

        <div>

            <!-- Top navbar -->
            <modal-header
                :title="title"
                :right="'close-dark'"
                :noIcon="true">
            </modal-header>

            <template>

                <!-- Loading animation -->
                <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

                <!-- Prompt content -->
                <prompt-div class="text-dark" v-if="!initLoad">

                    <!-- Layout body -->
                    <template v-slot:body>

                        <!-- Product image -->
                        <div class="product-image-section d-flex position-relative mt-4">
                            <div class="card-image-container d-flex justify-content-center m-auto">
                                <img class="card-image img img-fluid" :src="'/image/' + productImage" @error="$root.imageAlt" alt="">
                            </div>
                        </div>

                        <div class="pt-6">
                            <h3 class="font-lg font-weight-bolder">You can now apply for your pre-ordered item</h3>
                            <h4 class="font-md mt-5">You have pre-ordered {{ product.productName }}. You can now proceed to application and finish the purchase.</h4>
                        </div>
                        <button class="btn btn-md btn-inverted text-primary px-7 mt-6" @click="apply">
                            Yay, apply for it now!
                        </button>
                        <div class="pt-6">
                            <span class="font-sm font-weight-bolder text-primary" @click="cancel">I don't want this item anymore</span>
                        </div>

                    </template>

                </prompt-div>

            </template>

        </div>

    </modal-container>

</template>

<script>
    export default {
        props: {
            params: {
                default: null,
            },
        },

        data: function() {
            return {
                initLoad: true,
                animationData: require('../../assets/mpl-loan-terms.json'),
                product: {
                    productName: ''
                },
            }
        },

        computed: {
            title: function() {
                return this.product.productName ? 'Pre-order ' + this.product.productName : ''
            },
            productImage: function() {
                return this.product.imageId? this.product.imageId[0] : 0
            }
        },

        created: function() {
            axios
                .get("product/" + this.params.id)
                .then(response => {
                    this.initLoad = false
                    this.product = response.data['product']
                })
        },

        methods: {
            cancel() {
                this.initLoad = true
                axios
                    .post("preorder/cancel")
                    .then(response => {
                        if(response.data.product) {
                            this.$root.updateState()

                            this.$root.openModal('modal_preorder_cancellation', { name: this.product.productName })
                        }

                        this.initLoad = false
                    })
            },

            apply() {
                this.initLoad = true
                this.$root.triggerPageGEvent('/apply', { product: this.product.id })

                axios
                    .post("preorder/apply")
                    .then(response => {
                        if(response.data.product) {
                            // if mobile
                            window.location.replace("exit?location=forms");
                        }

                        this.initLoad = false
                    })
            }
        }
    }
</script>

<style scoped>
    .product-image-section {
        min-height: 10rem;
        max-height: 13rem;
    }
    .card-image-container {
        max-height: inherit;
        max-width: 100%;
    }
    .card-image {
        object-fit: cover;
        object-position: center;
        max-height: inherit;
        max-width: inherit;
    }
</style>